export var ManifestType;
(function (ManifestType) {
    ManifestType[ManifestType["Branch"] = 0] = "Branch";
    ManifestType[ManifestType["Release"] = 1] = "Release";
})(ManifestType || (ManifestType = {}));
